import React, { createContext, useState } from "react";

// ================= APP CONTEXT =================

const AppContext = createContext();

export const AppProvider = ({ children }) => {

  // ================= BASIC STATE =================

  // For Development
  // const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  // const [baseUrlForFile, setBaseUrlForFile] = useState("http://127.0.0.1:8000/storage");

  // For Production
  const [baseUrl, setBaseUrl] = useState("https://workhub.btsportfolio2026.com/backend/public/api");
  const [baseUrlForFile, setBaseUrlForFile] = useState("https://workhub.btsportfolio2026.com/backend/public/storage");

  // const [baseUrl, setBaseUrl] = useState("https://picks4tips.com/backend/public/api");
  // const [baseUrlForFile, setBaseUrlForFile] = useState("https://picks4tips.com/backend/public/storage");

  const [loggedInCustomer, setLoggedInCustomer] = useState(null);
  const [selectedCategoryForProducts, setSelectedCategoryForProducts] = useState("");
  const [authToken, setAuthToken] = useState("");
  const [kycStatus, setKycStatus] = useState(null);
  const [workerProfile, setWorkerProfile] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);

  // ================= SIMPLE REGEX =================

  // Only letters and spaces
  const fullNameRegex = /^[A-Za-z ]+$/;

  // Simple email regex
  const emailRegex = /^\S+@\S+\.\S+$/;

  // Password minimum 6 characters
  const passwordRegex = /^.{6,}$/;

  // Phone number only digits, minimum 10 digits
  const phoneNoRegex = /^(\+?\d{1,4})?\d{10,}$/;

  // City only letters and spaces
  const cityRegex = /^[A-Za-z ]+$/;



  // SNS
  const ssnRegex = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/;
  // Job Title
const jobTitleRegex = /^[A-Za-z0-9\s.,()&'-]{5,100}$/;

// Description
const descriptionRegex = /^.{20,1000}$/;

// Budget
const budgetRegex = /^[1-9]\d*$/;

// Address
const addressRegex = /^[A-Za-z0-9\s,#./()-]{10,255}$/;

  // ================= VALIDATION FUNCTION =================

  const RegExpChecker = (type, input) => {
    switch (type) {

      case "fullName":
        if (!fullNameRegex.test(input)) {
          return {
            fullName: "Name should contain only letters.",
          };
        }
        return { fullName: "" };

      case "email":
        if (!emailRegex.test(input)) {
          return {
            email: "Please enter a valid email.",
          };
        }
        return { email: "" };

      case "password":
        if (!passwordRegex.test(input)) {
          return {
            password: "Password must be at least 6 characters.",
          };
        }
        return { password: "" };

      case "phone":
        if (!phoneNoRegex.test(input)) {
          return {
            phone: "Phone number must contain at least 10 digits.",
          };
        }
        return { phone: "" };

      case "city":
        if (!cityRegex.test(input)) {
          return {
            city: "City name should contain only letters.",
          };
        }
        return { city: "" };



      case "ssn":
        if (!ssnRegex.test(input)) {
          return {
            ssn: "Invalid SSN. Please enter in this format: 987-65-4321",
          };
        }
        return { ssn: "" };

case "jobTitle":
  if (!jobTitleRegex.test(input)) {
    return {
      jobTitle: "Job title must be between 5 and 100 characters."
    };
  }
  return { jobTitle: "" };

case "description":
  if (!descriptionRegex.test(input)) {
    return {
      description: "Description must be at least 20 characters."
    };
  }
  return { description: "" };

case "budget":
  if (!budgetRegex.test(input)) {
    return {
      budget: "Budget must be greater than 0."
    };
  }
  return { budget: "" };

case "address":
  if (!addressRegex.test(input)) {
    return {
      address: "Please enter a valid address."
    };
  }
  return { address: "" };

      default:
        return {};
    }
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        baseUrlForFile,

        authToken,
        setAuthToken,

        loggedInCustomer,
        setLoggedInCustomer,

        selectedCategoryForProducts,
        setSelectedCategoryForProducts,

        RegExpChecker,

        kycStatus,
        setKycStatus,
        workerProfile,
        setWorkerProfile,

        dashboardData,
        setDashboardData,


      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;